export const ajaxRequests = () => {
  const mediaDropdowns = document.querySelectorAll(".media--dropdown");
  //   console.log("Found media dropdowns:", mediaDropdowns.length);

  if (mediaDropdowns.length > 0) {
    const grid = document.querySelector(".media--grid");
    const filters = document.getElementById("media--filters");
    const loadMoreContainer = document.getElementById("media--load-more");
    const loadMoreButton = document.getElementById("media--load-more__button");

    // console.log("DOM Elements found:", {
    //   grid: !!grid,
    //   filters: !!filters,
    //   loadMoreContainer: !!loadMoreContainer,
    //   loadMoreButton: !!loadMoreButton,
    // });

    // Initialize from URL parameters
    const initializeFromUrl = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const showDailyBuybacks = urlParams.get("show_daily_buybacks");
      const categoryValue = urlParams.get("cat");
      const yearValue = urlParams.get("year");
      const dailyBuybacksCheckbox = document.getElementById(
        "media-filter--daily-buybacks"
      );

      // Set checkbox state based on URL
      if (dailyBuybacksCheckbox) {
        dailyBuybacksCheckbox.checked = showDailyBuybacks === "true";
      }

      // Handle checkbox enable/disable based on category
      if (dailyBuybacksCheckbox) {
        if (
          categoryValue &&
          categoryValue !== "" &&
          categoryValue !== "share-repurchases"
        ) {
          dailyBuybacksCheckbox.disabled = true;
          dailyBuybacksCheckbox.checked = false;
        } else {
          dailyBuybacksCheckbox.disabled = false;
        }
      }

      // Set category dropdown - reset to "All" if no parameter
      const categoryDropdown = document.getElementById(
        "media-filter--category"
      );
      if (categoryDropdown) {
        categoryDropdown.value = categoryValue || "";
        // Refresh Selectric if it's initialized
        if ($(categoryDropdown).data("selectric")) {
          $(categoryDropdown).selectric("refresh");
        }
      }

      // Set year dropdown - reset to "All" if no parameter
      const yearDropdown = document.getElementById("media-filter--year");
      if (yearDropdown) {
        if (yearValue) {
          // Find option that contains the year value
          const options = yearDropdown.querySelectorAll("option");
          let matchingOption = null;

          for (let option of options) {
            if (option.value.includes(yearValue)) {
              matchingOption = option;
              break;
            }
          }

          if (matchingOption) {
            yearDropdown.value = matchingOption.value;
          }
        } else {
          // Reset to "All" (empty value)
          yearDropdown.value = "";
        }

        // Refresh Selectric if it's initialized
        if ($(yearDropdown).data("selectric")) {
          $(yearDropdown).selectric("refresh");
        }
      }
    };

    // Initialize on load
    initializeFromUrl();

    // Always check if we need to update results on page load
    const urlParamsCheck = new URLSearchParams(window.location.search);
    const categoryValueCheck = urlParamsCheck.get("cat");
    const yearValueCheck = urlParamsCheck.get("year");
    const showDailyBuybacksCheck = urlParamsCheck.get("show_daily_buybacks");

    // We need to update results if there are parameters OR if we're coming from a filtered state
    // Small delay to ensure dropdowns are initialized
    setTimeout(() => {
      if (categoryValueCheck || yearValueCheck || showDailyBuybacksCheck) {
        // console.log("URL parameters found, updating results on page load");
        updateMediaResults("true"); // isNewSearch = true for initial load with parameters
      } else {
        // console.log("No URL parameters, checking if filters need reset");
        // Check if dropdowns/checkbox are in a non-default state and need resetting
        const currentCategoryValue = document.getElementById(
          "media-filter--category"
        )?.value;
        const currentYearValue =
          document.getElementById("media-filter--year")?.value;
        const currentCheckboxValue = document.getElementById(
          "media-filter--daily-buybacks"
        )?.checked;

        if (currentCategoryValue || currentYearValue || currentCheckboxValue) {
          // console.log("Filters need reset, updating results to show all posts");
          updateMediaResults("true"); // Reset to show all posts
        }
      }
    }, 100);

    // Handle browser back/forward navigation
    window.addEventListener("popstate", function () {
      // console.log("Popstate event triggered in ajax.js");
      initializeFromUrl();
      // Update results to reflect the new URL state
      updateMediaResults("true"); // isNewSearch = true for navigation

      // Also apply nav state based on scroll
      if (typeof window.applyNavStateBasedOnScroll === "function") {
        window.applyNavStateBasedOnScroll();
      }
    });

    // Handle category changes and checkbox state
    function handleCategoryChange(selectedValue) {
      const dailyBuybacksCheckbox = document.getElementById(
        "media-filter--daily-buybacks"
      );
      const currentUrl = new URL(window.location);

      // Update category parameter in URL
      if (selectedValue && selectedValue !== "") {
        currentUrl.searchParams.set("cat", selectedValue);
      } else {
        currentUrl.searchParams.delete("cat");
      }

      // Remove pagination when filters change
      currentUrl.searchParams.delete("page");

      if (
        selectedValue &&
        selectedValue !== "" &&
        selectedValue !== "share-repurchases"
      ) {
        // Disable checkbox and uncheck it for non-Share Repurchases categories
        if (dailyBuybacksCheckbox) {
          dailyBuybacksCheckbox.disabled = true;
          dailyBuybacksCheckbox.checked = false;
        }
        currentUrl.searchParams.delete("show_daily_buybacks");
      } else {
        // Enable checkbox for All or Share Repurchases
        if (dailyBuybacksCheckbox) {
          dailyBuybacksCheckbox.disabled = false;
        }
      }

      // Update browser history
      window.history.pushState({}, "", currentUrl.toString());
    }

    // Handle year changes
    function handleYearChange(selectedValue) {
      const currentUrl = new URL(window.location);

      // Extract year from the value (last parameter in URL)
      let yearValue = selectedValue;

      if (selectedValue && selectedValue.includes("/")) {
        const parts = selectedValue.split("/");
        yearValue = parts[parts.length - 2];
      }

      // Update year parameter in URL
      if (yearValue && yearValue !== "") {
        currentUrl.searchParams.set("year", yearValue);
      } else {
        currentUrl.searchParams.delete("year");
      }

      // Remove pagination when filters change
      currentUrl.searchParams.delete("page");

      // Update browser history
      window.history.pushState({}, "", currentUrl.toString());
    }

    // Dropdown change event - using Selectric events
    mediaDropdowns.forEach((dropdown, index) => {
      //   console.log(`Setting up dropdown ${index}:`, dropdown);

      // Use Selectric's change event
      $(dropdown).on("selectric-change", function (event, element, selectric) {
        // console.log("Selectric dropdown changed:", $(this).val());
        const selectedValue = $(this).val();

        // Handle different dropdown types
        if (dropdown.id === "media-filter--category") {
          handleCategoryChange(selectedValue);
        } else if (dropdown.id === "media-filter--year") {
          handleYearChange(selectedValue);
        }

        updateMediaResults("true"); // isNewSearch = true for dropdown
      });

      // Also listen for native change as fallback
      dropdown.addEventListener("change", function (e) {
        // console.log("Native dropdown changed:", e.target.value);
        e.preventDefault();
        const selectedValue = e.target.value;

        // Handle different dropdown types
        if (dropdown.id === "media-filter--category") {
          handleCategoryChange(selectedValue);
        } else if (dropdown.id === "media-filter--year") {
          handleYearChange(selectedValue);
        }

        updateMediaResults("true"); // isNewSearch = true for dropdown
      });
    });

    // Load more button event (delegated)
    if (loadMoreContainer) {
      loadMoreContainer.addEventListener("click", function (e) {
        if (e.target && e.target.id === "media--load-more__button") {
          e.preventDefault();
          // console.log("Load more button clicked");
          updateMediaResults("false"); // isNewSearch = false for load more
        }
      });
    }

    // Handle daily buybacks checkbox changes
    const dailyBuybacksCheckbox = document.getElementById(
      "media-filter--daily-buybacks"
    );
    if (dailyBuybacksCheckbox) {
      dailyBuybacksCheckbox.addEventListener("change", function (e) {
        const isChecked = e.target.checked;
        const currentUrl = new URL(window.location);

        // Update or add the show_daily_buybacks parameter to the URL
        if (isChecked) {
          currentUrl.searchParams.set("show_daily_buybacks", "true");
        } else {
          currentUrl.searchParams.delete("show_daily_buybacks");
        }

        // Remove any pagination from URL when filters change
        currentUrl.searchParams.delete("page");

        // console.log("Daily buybacks toggle:", isChecked);
        // console.log(currentUrl.toString());
        // Update browser history without reloading the page
        window.history.pushState({}, "", currentUrl.toString());

        updateMediaResults("true"); // isNewSearch = true for filter change

        // Also apply nav state based on scroll
        if (typeof window.applyNavStateBasedOnScroll === "function") {
          window.applyNavStateBasedOnScroll();
        }
      });
    }

    // Reset filters event
    function resetDropdowns() {
      mediaDropdowns.forEach((dropdown) => {
        // Reset native select
        dropdown.selectedIndex = 0;

        // Reset Selectric dropdown
        $(dropdown).selectric("refresh");
      });

      // Reset checkbox
      if (dailyBuybacksCheckbox) {
        dailyBuybacksCheckbox.checked = false;
      }
    }

    document.addEventListener("click", function (e) {
      if (e.target && e.target.id === "media--reset-filters") {
        e.preventDefault();
        // console.log("Reset filters clicked");
        resetDropdowns();
        updateMediaResults("true");
      }
    });

    function setLoadingState(isLoading) {
      if (!filters) return;
      if (isLoading) {
        filters.classList.add("is-loading");
        filters.style.cursor = "wait";
        filters
          .querySelectorAll("input, button, select, label")
          .forEach((el) => {
            el.style.cursor = "wait";
          });
      } else {
        filters.classList.remove("is-loading");
        filters.style.cursor = "auto";
        filters
          .querySelectorAll("input, button, select, label")
          .forEach((el) => {
            el.style.cursor = "auto";
          });
      }
    }

    function updateMediaResults(isNewSearch) {
      if (!filters || !grid) return;

      const year = document.getElementById("media-filter--year")?.value;
      const cat = document.getElementById("media-filter--category")?.value;
      const next = loadMoreButton?.getAttribute("data-next");
      const nonce = window.localized_object?.nonce;
      const ajaxUrl = window.localized_object?.ajax_url;

      //   console.log("AJAX Request:", {
      //     year,
      //     cat,
      //     next,
      //     isNewSearch,
      //     nonce: nonce ? "present" : "missing",
      //     ajaxUrl: ajaxUrl ? "present" : "missing",
      //   });

      setLoadingState(true);

      fetch(ajaxUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: new URLSearchParams({
          action: "get_media_form",
          year: year || "",
          cat: cat || "",
          show_daily_buybacks: document.getElementById(
            "media-filter--daily-buybacks"
          )?.checked
            ? "true"
            : "false",
          next: next || "",
          isNewSearch: isNewSearch || "",
          nonce: nonce || "",
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          //   console.log("AJAX Response:", response);

          const gridOffset = grid.getBoundingClientRect();
          if (isNewSearch === "true") {
            window.scrollTo({
              top: window.scrollY + gridOffset.top - 85,
              behavior: "smooth",
            });
          }

          if (response && typeof response.media !== "undefined") {
            if (response.media.length > 0) {
              if (isNewSearch === "true") {
                grid.innerHTML = response.media;
              } else {
                grid.insertAdjacentHTML("beforeend", response.media);
              }
            } else {
              grid.innerHTML =
                '<p id="media--no-results" class="h4 padding-top-60 padding-bottom-60">No Results Found. <a id="media--reset-filters" href="#">Reset Filters</a></p>';
            }
          }

          if (isNewSearch === "true" && loadMoreButton) {
            loadMoreButton.setAttribute("data-next", 1);
          }

          if (loadMoreButton) {
            if (response.next_page <= response.max_pages) {
              loadMoreButton.style.display = "";
              loadMoreButton.setAttribute("data-next", response.next_page);
            } else {
              loadMoreButton.style.display = "none";
              loadMoreButton.setAttribute("data-next", 1);
            }
          }
        })
        .catch((err) => {
          // console.error("AJAX Error:", err);
        })
        .finally(() => {
          setLoadingState(false);
        });
    }
  }
};
